/* eslint-disable no-return-assign */
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import Select from 'react-select';
import PropTypes from 'prop-types';
import * as actions from '../action';

function ChangeColorModal({ data, showTransaction, id, cardColorChange }) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    nature_of_work: '',
  });

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const onChangeSelect = (key) => (item) => {
    setFormData({
      ...formData,
      [key]: _.get(item, 'value'),
    });
  };

  const onChangeColor = (e) => {
    e.preventDefault();
    if (!_.get(formData, 'nature_of_work')) {
      Alert.warning('Card Color Field is Required');
      return;
    }

    cardColorChange(_.get(data, 'id'), formData, () => {
      showTransaction(_.get(data, 'id'));
      setModal({ isOpen: false });
    });
  };

  const options = [
    { label: 'WHITE', value: 'WHITE_CARD' },
    { label: 'GREEN', value: 'GREEN_CARD' },
    { label: 'PINK', value: 'PINK_CARD' },
  ];

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <div className="row">
            <div className="col-12 ">
              <div className="form-input-group">
                <label className="form-control-plaintext">Card Color</label>
                <Select
                  value={
                    options.find(
                      (item) =>
                        _.get(item, 'value') ===
                        _.get(formData, 'nature_of_work')
                    ) || {}
                  }
                  onChange={onChangeSelect('nature_of_work')}
                  options={options}
                />
              </div>
            </div>

            <div className="col-12">
              <div className="form-input-group">
                <label className="form-control-plaintext">&nbsp;</label>
                <button
                  type="button"
                  className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary "
                  onClick={onChangeColor}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
      </div>
    </Modal.Body>
  );
}

ChangeColorModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  cardColorChange: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.instanceOf(String).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeColorModal);
